import { render, staticRenderFns } from "./SmsPhoneNumber.vue?vue&type=template&id=f506e83a"
import script from "./SmsPhoneNumber.vue?vue&type=script&lang=js"
export * from "./SmsPhoneNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports